import { render, staticRenderFns } from "./EducationalJoiningApplicationAdd.vue?vue&type=template&id=44920c86&"
import script from "./EducationalJoiningApplicationAdd.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports